import Axios from "axios";

export const AddressLookupDetailsAPI = async (id) => {
 try {
   const res = await Axios({
     method: "GET",
     url: `${process.env.REACT_APP_BASE_URL}/address-lookup-details/${id}`,
     headers: {
       "Content-Type": "application/json",
     },
   });
   return res?.data;
 } catch (err) {
   return err?.response?.data;
 }
};